/* eslint-disable */
import React from "react";
import RenderITOfficerPage from "../RenderITOfficerPage";
import FundContributionAnalysisPanel from "../../Components/FundContributionAnalysisPanel";

function LoanDeductionAnalysis() {
  return (
    <RenderITOfficerPage title="Loan Deduction Analysis">
      <FundContributionAnalysisPanel accent="cyan" variant="loans" />
    </RenderITOfficerPage>
  );
}

export default LoanDeductionAnalysis;
